import O1HD from "../../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { OreSelectEntity, OreSelectEntityConfig } from "./config/OreConfig";
import MineLandNode from "./MineLandNode";
import mineLandStartItem from "./mineLandStartItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class mineLandStartPage extends cc.Component {

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"item预制体"})
    itemPrefab:cc.Prefab = null;

    onLoad(): void {
        this.loadPage();
    }

    loadPage(){
        let itemConfig:OreSelectEntity[] = OreSelectEntityConfig();
        for(let i = 0;i<itemConfig.length;i++){
            let config = itemConfig[i];
            let item = cc.instantiate(this.itemPrefab);
            let is = item.getComponent(mineLandStartItem);
            is.bindData(config,this.selectOne);
            this.itemContent.addChild(item);
        }
    }
    
    async selectOne(config:OreSelectEntity){
        let url = "prefab/mineLandNode";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.mineLandGameBundle,url);
        let mineLandPrefab = cc.instantiate(prefab);
        let ms = mineLandPrefab.getComponent(MineLandNode);
        ms.bindData(config);
        O1HD.Canvas().addChild( mineLandPrefab );
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }
}
